import ArchitectureIcon from "@mui/icons-material/Architecture";
import DomainIcon from "@mui/icons-material/Domain";
import PeopleIcon from "@mui/icons-material/People";
import InventoryIcon from "@mui/icons-material/Inventory";
import BadgeIcon from "@mui/icons-material/Badge";
import HandshakeIcon from "@mui/icons-material/Handshake";
import WorkIcon from "@mui/icons-material/Work";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import StorageIcon from "@mui/icons-material/Storage";
import AppsIcon from "@mui/icons-material/Apps";
import DnsIcon from "@mui/icons-material/Dns";
import PlaceIcon from "@mui/icons-material/Place";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import FlagIcon from "@mui/icons-material/Flag";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import FavoriteIcon from "@mui/icons-material/Favorite";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import LaptopIcon from "@mui/icons-material/Laptop";
import BugReportIcon from "@mui/icons-material/BugReport";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import RuleIcon from "@mui/icons-material/Rule";
import DatasetIcon from "@mui/icons-material/Dataset";
import DataThresholdingIcon from "@mui/icons-material/DataThresholding";
import CategoryIcon from "@mui/icons-material/Category";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import BarChartIcon from "@mui/icons-material/BarChart";
import ScienceIcon from "@mui/icons-material/Science";
import RepeatIcon from "@mui/icons-material/Repeat";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import MapIcon from "@mui/icons-material/Map";
import DataObjectIcon from "@mui/icons-material/DataObject";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import HandymanIcon from "@mui/icons-material/Handyman";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";

// ── 設計セクション ──
export const DESIGN_CHILDREN = [
  // 戦略マップ グループ
  { key: "strategyMap", labelKey: "tree.strategyMap", icon: MapIcon, route: null, group: true,
    children: [
      { key: "smChart",               labelKey: "tree.smChart",               icon: AccountTreeIcon,   route: "strategy-map/chart" },
      { key: "smFinancialGoals",      labelKey: "tree.smFinancialGoals",      icon: TrendingUpIcon,    route: "strategy-map/financial-goals" },
      { key: "smCustomerValues",      labelKey: "tree.smCustomerValues",      icon: FavoriteIcon,      route: "strategy-map/customer-values" },
      { key: "smStrategicGoals",      labelKey: "tree.smStrategicGoals",      icon: TrackChangesIcon,  route: "strategy-map/strategic-goals" },
      { key: "smStrategicIssues",     labelKey: "tree.smStrategicIssues",     icon: ReportProblemIcon, route: "strategy-map/strategic-issues" },
      { key: "smHumanCapitalGoals",   labelKey: "tree.smHumanCapitalGoals",   icon: GroupsIcon,        route: "strategy-map/human-capital-goals" },
      { key: "smInfoCapitalGoalsApp", labelKey: "tree.smInfoCapitalGoalsApp", icon: LaptopIcon,        route: "strategy-map/info-capital-goals-app" },
      { key: "smInfoCapitalGoalsData",labelKey: "tree.smInfoCapitalGoalsData",icon: DatasetIcon,       route: "strategy-map/info-capital-goals-data" },
      { key: "smInfoCapitalGoalsIt",  labelKey: "tree.smInfoCapitalGoalsIt",  icon: DnsIcon,           route: "strategy-map/info-capital-goals-it" },
      { key: "smOrgCapitalGoals",     labelKey: "tree.smOrgCapitalGoals",     icon: CorporateFareIcon, route: "strategy-map/org-capital-goals" },
    ],
  },

  // 資産 グループ（顧客タイプ〜財務資産タイプ）
  // ※ データドメインは企業ドメインのみ表示予定（enterprise フラグ追加後に対応）
  { key: "assets", labelKey: "tree.assets", icon: CategoryIcon, route: null, group: true,
    children: [
      { key: "customerTypes",       labelKey: "tree.customerTypes",       icon: PeopleIcon,         route: "customer-types" },
      { key: "productTypes",        labelKey: "tree.productTypes",        icon: InventoryIcon,      route: "product-types" },
      { key: "memberTypes",         labelKey: "tree.memberTypes",         icon: BadgeIcon,          route: "member-types" },
      { key: "partnerTypes",        labelKey: "tree.partnerTypes",        icon: HandshakeIcon,      route: "partner-types" },
      { key: "dataDomains",         labelKey: "tree.dataDomains",         icon: DataObjectIcon,     route: "data-domains", enterpriseOnly: true },
      { key: "dataTypes",           labelKey: "tree.dataTypes",           icon: StorageIcon,        route: "data-types" },
      { key: "applicationTypes",    labelKey: "tree.applicationTypes",    icon: AppsIcon,           route: "application-types" },
      { key: "itTypes",             labelKey: "tree.itTypes",             icon: DnsIcon,            route: "it-types" },
      { key: "financialAssetTypes", labelKey: "tree.financialAssetTypes", icon: AccountBalanceIcon, route: "financial-asset-types" },
    ],
  },

  // 場所 グループ
  { key: "places", labelKey: "tree.places", icon: PlaceIcon, route: null, group: true,
    children: [
      { key: "placeTypes", labelKey: "tree.placeTypes", icon: PlaceIcon, route: "place-types" },
    ],
  },

  // 機能 グループ
  { key: "functions", labelKey: "tree.functions", icon: WorkIcon, route: null, group: true,
    children: [
      { key: "jobs", labelKey: "tree.jobs", icon: WorkIcon, route: "jobs" },
    ],
  },

  // 活動 グループ
  { key: "activities", labelKey: "tree.activities", icon: AccountTreeIcon, route: null, group: true,
    children: [
      { key: "businessProcesses", labelKey: "tree.businessProcesses", icon: AccountTreeIcon, route: "business-processes" },
      { key: "valueChains",       labelKey: "tree.valueChains",       icon: RepeatIcon,      route: "value-chains" },
    ],
  },
];

// ── 戦略セクション ──
export const STRATEGY_CHILDREN = [
  // BSC グループ
  { key: "bsc", labelKey: "tree.bsc", icon: BarChartIcon, route: null, group: true,
    children: [
      { key: "bscFinancialGoals",      labelKey: "tree.financialGoals",      icon: TrendingUpIcon,    route: "bsc/financial-goals",        usesUnit: true },
      { key: "bscCustomerValues",      labelKey: "tree.customerValues",      icon: FavoriteIcon,      route: "bsc/customer-values",        usesUnit: true },
      { key: "bscStrategicGoals",      labelKey: "tree.smStrategicGoals",    icon: TrackChangesIcon,  route: "bsc/strategic-goals",        usesUnit: true },
      { key: "bscStrategicIssues",     labelKey: "tree.smStrategicIssues",   icon: ReportProblemIcon, route: "bsc/strategic-issues",       usesUnit: true },
      { key: "bscHumanCapitalGoals",   labelKey: "tree.humanCapitalGoals",   icon: GroupsIcon,        route: "bsc/human-capital-goals",    usesUnit: true },
      { key: "bscInfoCapitalGoalsApp", labelKey: "tree.infoCapitalGoalsApp", icon: LaptopIcon,        route: "bsc/info-capital-goals-app", usesUnit: true },
      { key: "bscInfoCapitalGoalsIt",  labelKey: "tree.infoCapitalGoalsIt",  icon: DnsIcon,           route: "bsc/info-capital-goals-it",  usesUnit: true },
      { key: "bscInfoCapitalGoalsData",labelKey: "tree.infoCapitalGoalsData",icon: DatasetIcon,       route: "bsc/info-capital-goals-data",usesUnit: true },
      { key: "bscOrgCapitalGoals",     labelKey: "tree.orgCapitalGoals",     icon: CorporateFareIcon, route: "bsc/org-capital-goals",      usesUnit: true },
    ],
  },

  // 資産 グループ（顧客カテゴリ〜財務資産カテゴリ）
  { key: "assets", labelKey: "tree.assets", icon: CategoryIcon, route: null, group: true,
    children: [
      { key: "customerCategories",       labelKey: "tree.customerCategories",       icon: PeopleIcon,         route: "customer-categories", usesUnit: true },
      { key: "productCategories",        labelKey: "tree.productCategories",        icon: InventoryIcon,      route: "product-categories", usesUnit: true },
      { key: "memberCategories",         labelKey: "tree.memberCategories",         icon: BadgeIcon,          route: "member-categories" },
      { key: "partnerCategories",        labelKey: "tree.partnerCategories",        icon: HandshakeIcon,      route: "partner-categories" },
      { key: "dataCategories",           labelKey: "tree.dataCategories",           icon: StorageIcon,        route: "data-categories", usesUnit: true },
      { key: "applicationCategories",    labelKey: "tree.applicationCategories",    icon: AppsIcon,           route: "application-categories" },
      { key: "itCategories",             labelKey: "tree.itCategories",             icon: DnsIcon,            route: "it-categories" },
      { key: "financialAssetCategories", labelKey: "tree.financialAssetCategories", icon: AccountBalanceIcon, route: "financial-asset-categories" },
    ],
  },

  // 場所 グループ
  { key: "places", labelKey: "tree.places", icon: PlaceIcon, route: null, group: true,
    children: [
      { key: "placeCategories", labelKey: "tree.placeCategories", icon: PlaceIcon, route: "place-categories" },
    ],
  },

  // 機能 グループ
  { key: "functions", labelKey: "tree.functions", icon: WorkIcon, route: null, group: true,
    children: [
      { key: "departments", labelKey: "tree.departments", icon: ApartmentIcon, route: "departments", usesUnit: true },
    ],
  },

  // 活動 グループ
  { key: "activities", labelKey: "tree.activities", icon: PlaylistAddCheckIcon, route: null, group: true,
    children: [
      { key: "actionPlans", labelKey: "tree.actionPlans", icon: PlaylistAddCheckIcon, route: "action-plans", usesUnit: true },
    ],
  },

  // 経営 グループ
  { key: "management", labelKey: "tree.management", icon: BusinessCenterIcon, route: null, group: true,
    children: [
      { key: "projects", labelKey: "tree.projects", icon: ScienceIcon,  route: "projects", usesUnit: true },
      { key: "programs", labelKey: "tree.programs", icon: RepeatIcon,   route: "programs", usesUnit: true },
    ],
  },
];

// ── 構築セクション ──
export const BUILD_CHILDREN = [
  // 機能 グループ
  { key: "functions", labelKey: "tree.functions", icon: WorkIcon, route: null, group: true,
    children: [
      { key: "departments", labelKey: "tree.departments", icon: ApartmentIcon, route: "departments", usesUnit: true },
    ],
  },

  // 経営 グループ
  { key: "management", labelKey: "tree.management", icon: BusinessCenterIcon, route: null, group: true,
    children: [
      { key: "projects", labelKey: "tree.projects", icon: ScienceIcon,  route: "projects", usesUnit: true },
      { key: "programs", labelKey: "tree.programs", icon: RepeatIcon,   route: "programs", usesUnit: true },
    ],
  },
];

export const TREE_ICONS = {
  companyValues: VolunteerActivismIcon,
  design: ArchitectureIcon,
  strategy: FlagIcon,
  build: HandymanIcon,
  businessDomain: DomainIcon,
};
